import classnames from "classnames";
import React from "react";

import { NO_VALUE_PLACEHOLDER } from "../../../components/table/helpers";

import "./AppStatus.scss";

export const AppStatus = ({ status }) => {
  if (!status) {
    return NO_VALUE_PLACEHOLDER;
  }

  const disabled = status === "disabled";
  const classes = classnames("app-status", {
    "app-status--disabled": disabled,
  });
  return <span className={classes}>{status}</span>;
};
